"use client";
import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@material-ui/core";

import {
  getUserPersonalInfo,
  toggle2FASettingAPI,
} from "../../../../api/userApi";
import { useStyles } from "./style";
import { showToast } from "../../../../utils/toast";

const TwoFA = () => {
  const classes = useStyles();
  const [is2FAEnabled, setIs2FAEnabled] = useState(false);
  const [loading2FA, setLoading2FA] = useState(false);

  useEffect(() => {
    getUserPersonalInfo()
      .then((res) => {
        setIs2FAEnabled(res?.data?.is2FAEnabled || false);
      })
      .catch((err) => {
        console.error("❌ Failed to fetch user info:", err);
      });
  }, []);

  const handle2FAToggle = async (enabled: boolean): Promise<void> => {
    try {
      setLoading2FA(true);
      await toggle2FASettingAPI(enabled);
      setIs2FAEnabled(enabled);
      showToast(
        `2FA ${enabled ? "enabled" : "disabled"} successfully`,
        "success",
      );
    } catch (err) {
      console.error("Failed to toggle 2FA:", err);
      showToast("Something went wrong while updating 2FA setting", "error");
    } finally {
      setLoading2FA(false);
    }
  };

  return (
    <Box className={classes.container}>
      <Box className={classes.contentWrapper}>
        <Box className={classes.settingLabelContainer}>
          <Box>
            <Typography className={classes.settingLabel}>
              Two-Factor Authentication (2FA)
            </Typography>
            <Typography className={classes.settingText}>
              We recommend you to turn on 2FA to protect your account <br />
              You will need access to your e-mail to confirm your login
            </Typography>
          </Box>
        </Box>

        <Box className={classes.toggleButtonGroup}>
          <Button
            variant="contained"
            className={
              !is2FAEnabled ? classes.activeButton : classes.inactiveButton
            }
            onClick={() => handle2FAToggle(false)}
            disabled={loading2FA}
          >
            Off
          </Button>
          <Button
            variant="contained"
            className={
              is2FAEnabled ? classes.activeButton : classes.inactiveButton
            }
            onClick={() => handle2FAToggle(true)}
            disabled={loading2FA}
          >
            On
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default TwoFA;
